"use client";
import { IContactImage } from "./consacts-image.types";

export const ContactsImage: IContactImage = ({ url, name }) => {
  return (
    <img
      src={url}
      loading={"lazy"}
      width={1920}
      height={665}
      alt={name}
      className="h-full object-cover"
    />
  );
};
